import { createSlice } from '@reduxjs/toolkit';

const initialState = {
};

const slice = createSlice({
  name: 'analytics',
  initialState,
  reducers: {
    track: (state, action) => ({
      ...state,
    }),
    pageView: (state, action) => ({
      ...state,
    }),
  }
});

export const {
    track,
    pageView
} = slice.actions;
    
  export default slice.reducer;